import { reactRoute } from '../../../utils/routing/reactRoute'

export const getDocumentsRoutes = (isClientDocumentsRoute: boolean) =>
  isClientDocumentsRoute ? reactRoute.organization.clientDocuments : reactRoute.organization.documents
